import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { BaseListComponent } from '@shared/components/base-list/base-list.component';
import { Config } from '@shared/configs/config';
import { ListService } from '@shared/modules/list/services/list.service';
import { ActivatedRoute } from '@angular/router';
import { ProjectContactsListConfig } from '@project-modules/project-contacts/shared/configs/project-contacts-list.config';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { Contact } from '@modules/contacts/shared/models/contact.model';
import { ProjectContactsFiltersComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contacts-filters/project-contacts-filters.component';
import { ProjectContactNameCellComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contact-name-cell/project-contact-name-cell.component';
import { ProjectContactTypeCellComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contact-type-cell/project-contact-type-cell.component';
import { ProjectContactPhoneCellComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contact-phone-cell/project-contact-phone-cell.component';
import { ProjectContactEmailCellComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contact-email-cell/project-contact-email-cell.component';
import { ProjectContactFunctionCellComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contact-function-cell/project-contact-function-cell.component';
import { ProjectContactsAddModalComponent } from '@project-modules/project-contacts/shared/components/project-contacts-add-modal/project-contacts-add-modal.component';
import { ProjectContactRoleCellComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contact-role-cell/project-contact-role-cell.component';
import { ProjectContactTagsCellComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/components/project-contact-tags-cell/project-contact-tags-cell.component';
import { ProjectPreviewService } from '@project-modules/project-preview/services/project-preview.service';
import { WindowHelper } from '@shared/helpers/window.helper';
import { ContactManagePanelService } from '@shared/modules/contact-sidenav/services/contact-manage-panel.service';
import { tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'project-contacts-list-component',
  templateUrl: './project-contacts-list.component.html',
  styleUrls: ['./project-contacts-list.component.scss']
})
export class ProjectContactsListComponent extends BaseListComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  ButtonTypes = ButtonTypes;
  ButtonSize = ButtonSize;
  ProjectContactsFiltersComponent = ProjectContactsFiltersComponent;
  WindowHelper = WindowHelper;
  projectId: number;

  @ViewChild('projectContactNameCellComponent')
  public projectContactNameCellComponent: ProjectContactNameCellComponent;
  @ViewChild('projectContactTypeCellComponent')
  public projectContactTypeCellComponent: ProjectContactTypeCellComponent;
  @ViewChild('projectContactPhoneCellComponent')
  public projectContactPhoneCellComponent: ProjectContactPhoneCellComponent;
  @ViewChild('projectContactEmailCellComponent')
  public projectContactEmailCellComponent: ProjectContactEmailCellComponent;
  @ViewChild('projectContactFunctionCellComponent')
  public projectContactFunctionCellComponent: ProjectContactFunctionCellComponent;
  @ViewChild('projectContactRoleCellComponent')
  public projectContactRoleCellComponent: ProjectContactRoleCellComponent;
  @ViewChild('projectContactTagsCellComponent')
  public projectContactTagsCellComponent: ProjectContactTagsCellComponent;

  constructor(
    public changes: ChangeDetectorRef,
    public listService: ListService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private projectPreviewService: ProjectPreviewService,
    private contactPanelService: ContactManagePanelService
  ) {
    super(changes, listService);
    this.checkProjectId();
    this.initListConfig(ProjectContactsListConfig);
    this.setOnSideNavCloseListener();
  }

  ngOnInit(): void {
    this.initActionSubscription();
  }

  private initActionSubscription(): void {
    this.projectPreviewService.actionEvent$
      .pipe(
        tap(() => this.addNewContact()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  checkProjectId() {
    if (this.route?.parent?.parent?.snapshot?.params?.projectId) {
      this.projectId = this.route?.parent?.parent?.snapshot?.params?.projectId;
      ProjectContactsListConfig.url = `${Config.API}/contact/search-advenced?filters[assignedProjects][]=${this.projectId}`;
    } else {
      ProjectContactsListConfig.url = `${Config.API}/contact/search-advenced?filters[assignedProjects][]=[{projectId}]`;
    }
  }

  addNewContact() {
    const dialog = this.dialog.open(ProjectContactsAddModalComponent, {
      width: Config.DEFAULT_MODAL_WIDTH,
      autoFocus: true
    });

    dialog.componentInstance.onChooseContact
      .pipe(
        tap(() => this.projectPreviewService.updateProject().add(() => this.listService.getRows())),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  showToggleMenu(row: Contact) {
    return !isNotNullOrUndefined(row.deleted);
  }

  setOnSideNavCloseListener(): void {
    this.contactPanelService.dataChanged$
      .pipe(
        tap(() => this.listService.getRows()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
